module.exports = "/packs/change-summary-c1689852dbf1fbbb03af1fe9e536fcaa.png";